import React, { useRef, useState, useEffect } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { Flex } from 'rebass'
import _has from 'lodash/fp/has'
import _getOr from 'lodash/fp/getOr'
import _, { set } from 'lodash'

import Button from '../Button'
import EkycDetail from './EkycDetailCard'
import SubHeading from '../Heading/SubHeading'
import { getCurrentApp, getErrors, getIsReuseEkycSelected } from '../../apps/selectors'
import SendLinkEkyc from 'e-submission/containers/Dialog/SendLinkEkyc'
import IdentifyEkycResponding from 'e-submission/containers/Dialog/IdentifyEkycResponding'
import DuplicateEkycCase from 'e-submission/containers/Dialog/DuplicateEkycCase'
import DuplicateRMSCaseCase from 'e-submission/containers/Dialog/DuplicateRMSCase'
import DopaRequestFailed from 'e-submission/containers/Dialog/DopaRequestFailed'
import EkycRevalidateAge from 'e-submission/containers/Dialog/EkycRevalidateAge'
import EkycOnDevice from 'e-submission/containers/Dialog/EkycOnDevice'
import EkycPreviewInfo from 'e-submission/containers/Dialog/EkycPreviewInfo'
import EkycStatus from 'e-submission/components/Card/EkycStatus'
import { IsRealDevice } from 'e-submission/utils'
import { getToggles } from 'quick-quote/feature-toggles'

import {
  createCaseEkyc,
  createCaseEkycFromDevice,
  verifyEkyc,
  setDopaRequestFailedModal,
  getAttachment,
  setFaceRecognitionImage,
  setFaceImage,
  setFrontPassportImage,
  setFrontIdCardImage,
  setBackIdCardLaserCode,
  setAppValue,
  enableEkycOnDevice,
  disabledEkycOnDevice,
  setOpenIdentifyRespondingModal,
} from '../../apps/actions'
import {
  getInsuredDopaResult,
  getPayerDopaResult,
  getInsuredDopaRequestFailed,
  getPayerDopaRequestFailed,
  isOnDeviceEKYC,
  getCitizenId,
  isQuickQuoteBancAgent,
  isSelectedRemoteSelling,
  getInsuredDopaResultResponseDataMessage,
  getPayerDopaResultResponseDataMessage,
  isForeigner,
  isSelectedF2F,
  getPassport,
  havePayer,
  hasConfirmationLetterFileInsured,
  hasConfirmationLetterFilePayer,
  hasInsuredIdCardFile,
  hasPayerIdCardFile,
  hasInsuredPassportFile,
  hasPayerPassportFile,
  isNeedConfirmationLetterSelector,
  hasInsuredFaceRecognitionImageFile,
  hasInsuredFaceImageFile,
  hasPayerFaceRecognitionImageFile,
  hasPayerFaceImageFile,
} from '../../domain/data-model/form/selectors'
import EkycValidation from 'e-submission/containers/AppForm/FormValidation/ekycValidation'

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  .btn-link {
    padding: 0;
    display: flex;
    color: inherit;
    align-items: center;
    border: none;
    &:hover,
    &:active,
    &:focus {
      color: inherit;
      border: none;
      outline: none;
      box-shadow: none;
    }
  }
`

const SubHeadingModified = styled(SubHeading)`
  color: ${({ theme }) => theme.variables['$brand-primary']};
`

const Container = styled.div`
  background: white;
  padding: 15px 15px;
  border-radius: 6px;
  box-shadow: 0 4px 5px 3px rgb(0 0 0 / 8%);
  .btn-outline-primary {
    border-radius: 4px;
  }
`

const Footer = styled.div`
  display: flex;
  justify-content: center;
`

const textMapping = {
  insured: 'ผู้ขอเอาประกัน',
  payer: 'ผู้ชำระเบี้ยประกัน',
}

export function findParentNodeTarget(domElement) {
  if (!domElement) return null
  if (domElement && domElement.className.match(/FormEngine/)) {
    return domElement
  } else {
    const parentDom = domElement.parentNode
    return findParentNodeTarget(parentDom)
  }
}

const EkycDocument = (props) => {
  const { insuredOrPayer } = props
  const dispatch = useDispatch()
  const app = useSelector((state) => getCurrentApp(state))
  const state = useSelector((state) => state)
  const refRootComponent = useRef(null)
  const hasPayer = havePayer(app)
  const [isSuccessSubmit, setIsSuccessSubmit] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [isShowDetail, setIsShowDetail] = useState(false)
  const [isOpenEkycOnDevice, setIsOpenEkycOnDevice] = useState(false)
  const [isOpenDuplicateModal, setIsOpenDuplicateModal] = useState(false)
  const [isOpenEkycPreviewInfoModal, setIsOpenEkycPreviewInfoModal] = useState(false)
  const [isOpenIdentifyRespondingModal, setIsOpenIdentifyRespondingModal] = useState(false)
  const isNeedConfirmationLetter = isNeedConfirmationLetterSelector(props.insuredOrPayer, app)

  const consentedConfirmationLetterInsured = _getOr(
    false,
    'ekycInfo.insured.verificationDetail.insurancePolicyAgreementResult.response.confirmationAccepted',
    app
  )
  const consentedConfirmationLetterPayer = _getOr(
    false,
    'ekycInfo.payer.verificationDetail.insurancePolicyAgreementResult.response.confirmationAccepted',
    app
  )
  const isInsuredIdFaceRecognitionVerify = _getOr(
    false,
    'ekycInfo.insured.verificationDetail.idFaceRecognitionResult.verified',
    app
  )
  const errors = getErrors(state)
  const ekycRootKey = 'ekycInfo'
  const insuredKey = 'insured'
  const payerKey = 'payer'
  const resendLinkKey = 'resendLink'
  const skippedKey = 'skipped'
  const verificationDetailKey = 'verificationDetail'
  const dopaResult = 'dopaResult'
  let cases = {}
  const insuredId = getCitizenId(insuredKey)(app)
  const payerId = getCitizenId(payerKey)(app)
  const resendValue = {
    insured: _getOr(false, [ekycRootKey, insuredKey, resendLinkKey], app),
    payer: _getOr(false, [ekycRootKey, payerKey, resendLinkKey], app),
  }
  const skipped = {
    insured: _getOr(false, [ekycRootKey, insuredKey, skippedKey], app),
    payer: _getOr(false, [ekycRootKey, payerKey, skippedKey], app),
  }
  const verificationDetail = _getOr({}, `ekycInfo.${props.insuredOrPayer}.${verificationDetailKey}`, app)
  const verifyStateOfDopa = {
    insured: getVerifyStateOfDopa(app, { ekycRootKey, verificationDetailKey, dopaResult }, insuredKey),
    payer: getVerifyStateOfDopa(app, { ekycRootKey, verificationDetailKey, dopaResult }, payerKey),
  }
  const isDuplicate = _has('EKYC_DUPLICATED_CITIZENID', errors)
  const isReuseCase = _has('EKYC_REUSE_CASE', errors)
  if (isDuplicate) {
    cases = errors['EKYC_DUPLICATED_CITIZENID'].cases
  }
  const hasError = _has('EKYC_VERIFY_CITIZENID', errors) || _has('EKYC_VERIFY_PROPRIETORID', errors)
  const isOpenDopaRequestFailedModal = _getOr(
    false,
    `ui.setDopaRequestFailedModal.${props.insuredOrPayer}.isOpenDopaRequestFailedModal`,
    state
  )
  const insuredPassportNumber = getPassport(insuredKey)(app)
  const payerPassportNumber = getPassport(payerKey)(app)
  const passportNumber = { insured: insuredPassportNumber, payer: payerPassportNumber }
  const insuredDopaVerified = getInsuredDopaResult(app)
  const payerDopaVerified = getPayerDopaResult(app)
  const insuredDopaRequestFailed = getInsuredDopaRequestFailed(app)
  const payerDopaRequestFailed = getPayerDopaRequestFailed(app)
  const insuredDopaResultResponseDataMessage = getInsuredDopaResultResponseDataMessage(app)
  const payerDopaResultResponseDataMessage = getPayerDopaResultResponseDataMessage(app)

  const proprietorId = _getOr(null, `ekycInfo.${props.insuredOrPayer}.proprietorId`, app)
  const isOnDeviceEkyc = isOnDeviceEKYC(app)

  const citizenIdValue = { insured: insuredId, payer: payerId }
  const isBancaUser = _getOr(null, `quickQuote.biProps.profile.agent_type`, app) === 'LB'

  const hasFaceRecognitionImageFile =
    props.insuredOrPayer === 'insured' ? hasInsuredFaceRecognitionImageFile(app) : hasPayerFaceRecognitionImageFile(app)

  const hasFaceImageFile =
    props.insuredOrPayer === 'insured' ? hasInsuredFaceImageFile(app) : hasPayerFaceImageFile(app)

  const isLoading = _.get(state, ['ui', 'isModalLoading'], false)
  const isAgeRevalidating = _.get(state, ['ui', 'isAgeRevalidating'], false)
  const checkedPremiumCalStatus = _getOr('Y', `checkedPremiumCalStatus`, app)
  const isReuseCaseSelected = getIsReuseEkycSelected(state)
  const selectedF2F = getToggles().ENABLE_APPMAN_REMOTE_SELLING ? isSelectedF2F(app) : true
  const selectedRemoteSelling = isSelectedRemoteSelling(app)
  const foreigner = isForeigner(app, props.insuredOrPayer)
  const isForeignerWithoutPassport =
    foreigner && !_.isEmpty(passportNumber[props.insuredOrPayer]) && passportNumber[props.insuredOrPayer].length === 13
  const isBancUser = isQuickQuoteBancAgent(app)
  const citizenId = citizenIdValue[insuredOrPayer]
  const resend = resendValue[insuredOrPayer]

  const successSubmitted = () => {
    setIsSuccessSubmit((prev) => !prev)
  }

  const clearFrontPassportImage = () => dispatch(setFrontPassportImage(null, insuredOrPayer))
  const clearFaceImage = () => dispatch(setFaceImage(null, insuredOrPayer))
  const clearFrontIdCardImage = () => dispatch(setFrontIdCardImage(null, insuredOrPayer))
  const clearBackIdCardLaserCode = () => dispatch(setBackIdCardLaserCode(null, insuredOrPayer))
  const clearFaceRecognitionImage = () => dispatch(setFaceRecognitionImage(null, insuredOrPayer))
  const closeDopaRequestFailedModal = () => dispatch(setDopaRequestFailedModal(false, insuredOrPayer))
  const createCase = (citizenId, passportNumber) => dispatch(createCaseEkyc(insuredOrPayer, citizenId, passportNumber))
  const createCaseFromDevice = (citizenId, openRespondModalOnFailedCase) => {
    dispatch(createCaseEkycFromDevice(insuredOrPayer, citizenId, openRespondModalOnFailedCase))
  }
  const verify = () => dispatch(verifyEkyc(insuredOrPayer))
  const getFronIdCard = () =>
    dispatch(getAttachment(insuredOrPayer === 'insured' ? 'insured-id-card' : 'owner-id-card', insuredOrPayer))
  const createEkycOptionDefaultValueForAgent = (ekycInfoIsOnDeviceValue, isBancUser) => {
    if (!getToggles().ENABLE_EKYC_ONDEVICE) return
    if (!IsRealDevice) {
      dispatch(disabledEkycOnDevice())
    } else if (typeof ekycInfoIsOnDeviceValue !== 'boolean' || isBancUser) {
      dispatch(enableEkycOnDevice())
    }
  }

  const getFaceRecognitionImage = () =>
    dispatch(
      getAttachment(
        props.insuredOrPayer === 'insured' ? 'insured-face-recognition' : 'owner-face-recognition',
        props.insuredOrPayer
      )
    )
  const getFaceImage = () =>
    dispatch(
      getAttachment(
        props.insuredOrPayer === 'insured' ? 'insured-face-image' : 'owner-face-image',
        props.insuredOrPayer
      )
    )

  const openModal = () => {
    setIsOpen(true)
  }
  const closeModal = () => {
    setIsOpen(false)
  }
  const setOffSendLinkEkycModal = () => closeModal()
  const setOnSendLinkEkycModal = () => openModal()
  const setShowEkycDetail = () => {
    setIsShowDetail(!isShowDetail)
  }
  const openEkycOnDeviceModal = (p) => {
    setIsOpenEkycOnDevice(p)
  }
  const closeEkycOnDeviceModal = () => {
    setIsOpenEkycOnDevice(false)
  }
  const setOffEkycOnDeviceModal = () => closeEkycOnDeviceModal()
  const setOnEkycOnDeviceModal = (p) => {
    openEkycOnDeviceModal(p)
  }
  const openDuplicateModal = () => {
    setIsOpenDuplicateModal(true)
  }
  const closeDuplicateModal = () => {
    setIsOpenDuplicateModal(false)
  }
  const closeEkycPreviewInfoModal = () => {
    setIsOpenEkycPreviewInfoModal(false)
  }

  const openIdentifyRespondingModal = () => {
    setIsOpenIdentifyRespondingModal(true)
  }
  const closeIdentifyRespondingModal = () => {
    setIsOpenIdentifyRespondingModal(false)
  }
  const openEkycPreviewInfoModal = () => {
    setIsOpenEkycPreviewInfoModal(true)
  }

  const handleRequestEkycFromDevice = (citizenId) => {
    function openRespondModalOnFailedCase() {
      openIdentifyRespondingModal()
    }
    createCaseFromDevice(citizenId, openRespondModalOnFailedCase)
    if (hasError || !isDuplicate) {
      openIdentifyRespondingModal()
    }
    openDuplicateModal()
  }

  const handlerRequestEkyc = (citizenId, passportNumber) => {
    createCase(citizenId, passportNumber)
    openDuplicateModal()
    if (hasError || !isDuplicate) {
      openIdentifyRespondingModal()
    }
  }

  useEffect(() => {
    clearFrontPassportImage()
    clearFrontIdCardImage()
    clearFaceImage()
    clearFaceRecognitionImage()
    clearBackIdCardLaserCode()
    if (selectedF2F) {
      getFronIdCard()
    } else {
      if (foreigner) {
        getPassport()
      } else {
        getFronIdCard()
      }
      if (hasFaceRecognitionImageFile && hasFaceImageFile) {
        getFaceRecognitionImage()
        getFaceImage()
      }
    }
  }, [])

  useEffect(() => {
    const formEngineDom = findParentNodeTarget(refRootComponent.current)
    createEkycOptionDefaultValueForAgent(isOnDeviceEkyc, isBancUser)

    if (!formEngineDom) return

    if (isBancaUser) {
      formEngineDom.style.maxWidth = '900px'
    }

    return () => {
      formEngineDom.style.maxWidth = ''
    }
  }, [])

  const isSkipped = skipped[insuredOrPayer]
  const isDopaVerified = verifyStateOfDopa[insuredOrPayer]

  const isEnableEkycOnDevice =
    getToggles().ENABLE_EKYC_ONDEVICE && getToggles().ENABLE_EKYC_F2F && IsRealDevice && isOnDeviceEkyc

  const getFunctionEKYC = () => {
    return isEnableEkycOnDevice ? handleRequestEkycFromDevice(citizenId, passportNumber) : setOnSendLinkEkycModal()
  }
  const consentedConfirmationLetter =
    props.insuredOrPayer === 'insured'
      ? isNeedConfirmationLetter
        ? consentedConfirmationLetterInsured
        : isInsuredIdFaceRecognitionVerify
      : consentedConfirmationLetterPayer
  const isVerificationCompleted = selectedF2F ? isDopaVerified : consentedConfirmationLetter

  const hasConfirmationLetterFile =
    props.insuredOrPayer === 'insured' ? hasConfirmationLetterFileInsured(app) : hasConfirmationLetterFilePayer(app)

  const hasIdCardFile = props.insuredOrPayer === 'insured' ? hasInsuredIdCardFile(app) : hasPayerIdCardFile(app)

  const hasPassportFile = props.insuredOrPayer === 'insured' ? hasInsuredPassportFile(app) : hasPayerPassportFile(app)

  return (
    <div ref={refRootComponent}>
      <EkycValidation />
      <Container>
        {isDuplicate && selectedF2F && (
          <DuplicateEkycCase
            successSubmitted={successSubmitted}
            isEnableEkycOnDevice={isEnableEkycOnDevice}
            isOpen={isOpenDuplicateModal}
            onExit={closeDuplicateModal}
            duplicateCase={cases}
            insuredOrPayer={insuredOrPayer}
            openIdentifyRespondingModal={openIdentifyRespondingModal}
            closeIdentifyRespondingModal={closeIdentifyRespondingModal}
          />
        )}
        {isDuplicate && selectedRemoteSelling && (
          <DuplicateRMSCaseCase
            successSubmitted={successSubmitted}
            isEnableEkycOnDevice={isEnableEkycOnDevice}
            isOpen={isOpenDuplicateModal}
            onExit={closeDuplicateModal}
            duplicateCase={cases}
            insuredOrPayer={insuredOrPayer}
            openIdentifyRespondingModal={openIdentifyRespondingModal}
            closeIdentifyRespondingModal={closeIdentifyRespondingModal}
            isNeedConfirmationLetter={isNeedConfirmationLetter}
          />
        )}
        {!isDuplicate && (
          <IdentifyEkycResponding
            isDuplicate={isDuplicate}
            insuredOrPayer={insuredOrPayer}
            identifyEkycRespond={
              isReuseCase ? (selectedRemoteSelling ? 'failedReuse' : 'warning') : hasError ? 'failed' : 'success'
            }
            isReuseCase={isReuseCase}
            isOpen={
              isOpenIdentifyRespondingModal &&
              !isLoading &&
              !isAgeRevalidating &&
              !(isOpenDuplicateModal && isDuplicate) &&
              !isOpenDopaRequestFailedModal &&
              !['N', 'NP', 'API Error'].includes(checkedPremiumCalStatus)
            }
            onExit={closeIdentifyRespondingModal}
            isReuseCaseSelected={isReuseCaseSelected}
            selectedRemoteSelling={selectedRemoteSelling}
          />
        )}
        <DopaRequestFailed
          insuredDopaRequestFailed={insuredDopaRequestFailed}
          payerDopaRequestFailed={payerDopaRequestFailed}
          insuredDopaVerified={insuredDopaVerified}
          payerDopaVerified={payerDopaVerified}
          insuredDopaResultResponseDataMessage={insuredDopaResultResponseDataMessage}
          payerDopaResultResponseDataMessage={payerDopaResultResponseDataMessage}
          isOpen={isOpenDopaRequestFailedModal && !isLoading && !isAgeRevalidating}
          onExit={closeDopaRequestFailedModal}
        />
        <SendLinkEkyc
          isOpen={isOpen}
          onExit={setOffSendLinkEkycModal}
          handlerCreateCaseEkyc={handlerRequestEkyc}
          insuredOrPayer={insuredOrPayer}
        />
        <EkycOnDevice
          isOpen={isOpenEkycOnDevice}
          onExit={setOffEkycOnDeviceModal}
          handlerCreateCaseEkyc={handlerRequestEkyc}
          insuredOrPayer={insuredOrPayer}
        />
        <EkycPreviewInfo
          isOpen={isOpenEkycPreviewInfoModal}
          onExit={closeEkycPreviewInfoModal}
          handlerCreateCaseEkyc={getFunctionEKYC}
          insuredOrPayer={insuredOrPayer}
        />
        <EkycRevalidateAge />
        <TitleContainer>
          <SubHeadingModified>{textMapping[insuredOrPayer]}</SubHeadingModified>
          {resend || isVerificationCompleted ? (
            <Button
              color="link"
              icon="redo"
              onClick={() => {
                openEkycPreviewInfoModal()
              }}
              disabled={isSkipped || isVerificationCompleted}
            >
              ส่งคำสั่งอีกครั้ง
            </Button>
          ) : (
            <Button
              onClick={() => {
                openEkycPreviewInfoModal()
              }}
              disabled={isSkipped}
            >
              ส่งคำสั่ง
            </Button>
          )}
        </TitleContainer>
        <EkycStatus
          detail={verificationDetail}
          selectedRemoteSelling={selectedRemoteSelling}
          foreigner={foreigner}
          isSkipped={isSkipped}
          hasPayer={hasPayer}
          isNeedConfirmationLetter={isNeedConfirmationLetter}
          insuredOrPayer={insuredOrPayer}
          hasConfirmationLetterFile={hasConfirmationLetterFile}
          hasIdCardFile={hasIdCardFile}
          hasPassportFile={hasPassportFile}
        />
        <Footer>
          {isShowDetail ? null : (
            <Button outline icon="arrowDown" onClick={() => setShowEkycDetail()}>
              แสดงข้อมูล
            </Button>
          )}
        </Footer>
        <EkycDetail
          setShowEkycDetail={setShowEkycDetail}
          detail={verificationDetail}
          isShowDetail={isShowDetail}
          insuredOrPayer={insuredOrPayer}
          selectedRemoteSelling={selectedRemoteSelling}
          foreigner={foreigner}
          isForeignerWithoutPassport={isForeignerWithoutPassport}
          isNeedConfirmationLetter={isNeedConfirmationLetter}
          hasConfirmationLetterFile={hasConfirmationLetterFile}
          hasFaceRecognitionImageFile={hasFaceRecognitionImageFile}
          hasFaceImageFile={hasFaceImageFile}
        />
      </Container>
    </div>
  )
}

function getVerifyStateOfDopa(app, keys, insuredOrPayer) {
  const { ekycRootKey, verificationDetailKey, dopaResult } = keys
  return (
    _getOr(false, [ekycRootKey, insuredOrPayer, verificationDetailKey, dopaResult, 'verified'], app) ||
    _getOr(false, [ekycRootKey, insuredOrPayer, verificationDetailKey, dopaResult, 'dopaRequestFailed'], app)
  )
}

export default EkycDocument
